class Register {
  // Constructor
  constructor(ids) {
    this.selectLists = ids;
    this.selectLists.forEach((id) => {
      if (document.querySelector(id)) {
        this.attachEvents(id);
      }
    });
  }

  // Attach events to the select list
  attachEvents(id) {
    let options = document.querySelectorAll(`${id} option`);
    options.forEach(function (element) {
      element.addEventListener(
        'mousedown',
        function (e) {
          e.preventDefault();
          element.parentElement.focus();
          this.selected = !this.selected;
          return false;
        },
        false
      );
    });
  }

  // Methods
}

export default Register;
